import { styled } from '@mui/material/styles'
import Tabs from '@mui/material/Tabs'

const FolderTabs = styled(Tabs)(({ theme }) => ({
  zIndex: 1000,
  marginBottom: -1.5,
  position: 'relative',
  minHeight: theme.spacing(4.5),
  '& .MuiTabs-indicator': {
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
    borderColor: theme.palette.contrast.minimal,
    borderStyle: 'solid',
    borderWidth: 1,
    borderBottom: 'none',
    zIndex: -1,
  },
  '& .MuiTab-root': {
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.caption.fontWeight,
    padding: theme.spacing(0),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    minHeight: theme.spacing(4),
    '&.Mui-selected, &:hover': {
      color: theme.palette.contrast.max,
    },
  },
}))

export default FolderTabs
